import { jsx as _jsx } from "react/jsx-runtime";
import { Banner } from '@yonderland/andes-react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { convertToCurrencySymbol } from '../../../../util/CurrencyUtil';
import { makeGetBasketPaybackVoucherMessagesState } from '../../../../redux/basket/selectors/BasketSelector';
export const PaybackVoucherMessage = () => {
    var _a;
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const paybackVoucherMessages = useSelector(makeGetBasketPaybackVoucherMessagesState());
    const validPaybackVoucherMessage = paybackVoucherMessages[0];
    if (!validPaybackVoucherMessage)
        return null;
    const feedbackMessageContext = ((_a = validPaybackVoucherMessage.customMessage) === null || _a === void 0 ? void 0 : _a.length) > 0
        ? validPaybackVoucherMessage.customMessage
        : t('checkout.basket.voucher.payback.message', {
            currency: convertToCurrencySymbol(validPaybackVoucherMessage.currency),
            amountUntilValid: validPaybackVoucherMessage.amountUntilValid.toFixed(2),
        });
    return _jsx(Banner, { status: "informative", text: feedbackMessageContext });
};
